<template>
  <h2 :class="titleClasses">
    <slot></slot>
  </h2>
</template>

<script>
export default {
  name: 'Title',
  props: {
    light: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    titleClasses () {
      return {
        'title': true,
        'light': this.light
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: $fs-h2;
  text-transform: uppercase;
  color: white;
  line-height: $lh-heading;
  text-align: center;
  margin-top: 0;
}

.light {
  color: $c-text;
}
</style>
